<template>
  <span>
    <DisplayEmpty v-if="status===0" :length="length" />
    <DisplayWaiting v-if="status===1" :length="length" />
    <DisplaySpinNumber v-if="status===2" :length="length" :wait="waiting" :result="result" />
    <DisplayResult v-if="status===3" :result="result" />
  </span>
</template>
<script>
import { slotItems } from '@/configs/slot.config.js'

import DisplayEmpty from './DisplayEmpty.vue'
import DisplayWaiting from './DisplayWaiting.vue'
import DisplaySpinNumber from './DisplaySpinNumber.vue'
import DisplayResult from './DisplayResult.vue'

export default {
  name: 'ShowNumbers',
  components: {
    DisplayEmpty,
    DisplayWaiting,
    DisplaySpinNumber,
    DisplayResult
  },
  props: {
    length: {
      type: [Number, String],
      required: true
    },
    results: {
      type: [Object, String],
    },
    resultKey: {
      type: String
    },
    updateCode: {
      type: Number,
      default: null
    },
    startSpin: {
      type: String,
      default: null
    },
    startShow: {
      type: String,
      default: null
    },
    endTime: {
      type: String,
      default: null
    },
    slotCounting: {
      type: String,
      default: null
    },
    distance: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      setTimeout: null,
      setTimeoutSpinNumber: null,
      step: null
    }
  },
  watch: {
    updateCode() {
      this.process()
    }
  },
  computed: {
    status() {
      return this.step
    },
    result() {
      if (this.results) {
        return this.results[this.resultKey]
      }else{
        return null
      }
    },
    waiting() {
      if (this.resultKey === 'prize_1st' && this.slotCounting === 'prize_1st') {
        if(this.endTime) {
          let diff = this.$moment(this.endTime).diff(this.$moment(), 'milliseconds')
          return diff
        }else {
          return false
        }
      } else
      if (this.slotCounting === this.resultKey) {
        let diff = this.$moment().diff(this.startShow, 'milliseconds')
        let distance = this.distance * 1000
        let wait = distance - (diff % this.distance)
        return wait
      }
      return 0
    }
  },
  methods: {
    process() {
      // ยังไม่ถึงเวลาเริ่มหมุน
      if(this.$moment().isBefore(this.startSpin)) {
        this.step = 0
        console.log(this.resultKey, this.step)
        // ตั้งค่า timeout เพื่อคำนวนสถานะอีกรอบ
        let diff = this.$moment(this.startSpin).diff(this.$moment(), 'milliseconds')
        clearTimeout(this.setTimeout)
        this.setTimeout = setTimeout(() => {
          this.process()
        }, diff)
      }else
      // ถ้ารางวัลที่ 2 ยังไม่มี ให้หมุนต่อไป
      if(!this.results['prize_2nd']) {
        this.step = 1
      }else
      // ถึงเวลาออกผลรางวัลที่ 1 แล้ว แต่ยังไม่มีผล
      if(this.resultKey === 'prize_1st' && this.slotCounting === 'prize_1st' && !this.result) {
        this.step = 2
      }else
      // ออกผลเสร็จหมดแล้ว
      if(this.$moment().isAfter(this.endTime)) {
        this.step = 3
      }else
      // กำลังหมุน
      if(this.$moment().isAfter(this.startSpin)) {
        if (this.slotCounting === this.resultKey) {
          if(this.waiting !== false && this.result && this.resultKey !== 'prize_1st') {
            this.step = 2
            this.setTimeoutSpinNumber = setTimeout(() => {
              this.$emit('changeSlot')
            }, this.waiting)
          }else
          if(this.resultKey === 'prize_1st'){
            this.step = 2
          }else{
            this.step = 1
          }
        } else {
          let slotIndex = slotItems.findIndex((item) => {
            return item === this.resultKey
          })
          let currentIndex = slotItems.findIndex((item) => {
            return item === this.slotCounting
          })
          if (currentIndex > slotIndex) {
            this.step = 3
          }else{
            this.step = 1
          }
        }
      }
    }
  },
  mounted() {
    //this.process()
  },
  beforeDestroy() {
    clearTimeout(this.setTimeout)
    clearTimeout(this.setTimeoutSpinNumber)
  }
}
</script>
